export enum BizBrowserFunctionNames {
  SEND_STATE = 'sendState',
}
